/**
 * Created by claudio iozzia on 28/06/2017.
 */
import {IAcceptor} from "../../../models/acceptor/IAcceptor";
import {Ic} from "../../../models/common";
import {
  TOPOLOGY_BOOST,
  TOPOLOGY_BUCK,
  TOPOLOGY_BUCK_BOOST,
  TOPOLOGY_FLOATING_BOOST,
  TOPOLOGY_FLOATING_BUCK_BOOST,
  TOPOLOGY_INVERTING_BUCK_BOOST,
  TOPOLOGY_POSITIVE_BUCK_BOOST
} from '../../../models/view';
import {IUpdateDesign, UpdateDesign} from "../../../models/IUpdateDesign";
import {IComparator} from "../../../models/IComparator";
import {IValidator} from "../../../models/validator/IValidator";
import {isNull} from "util";
import {IAppFactoryService} from "../../../Redux/selector.state";
import {Feature} from "../../../models/features/features";
import {Comparator_DcDc} from "../../POWER/dcdc/comparator";
import {Acceptor_DcLED_LEDBuckBoost} from "./acceptor/dcLED_LEDBuckBoost_acceptor";
import {UpdateDesign_DcLED_Buck, UpdateDesign_DcLED_BuckBoost} from "./update-design";
import {Validator_DcLED_BuckBoost} from "./validator/dcLED_buck_boost_validator";
import {Validator_DcLED_Buck} from "./validator/dcLED_buck_validator";
import {Validator_DcLED_Boost} from "./validator/dcLED_Boost_validator";
import {Validator_DcLED_PositiveBuckBoost} from "./validator/dcLED_positive_buck_boost_validator";
import {Validator_LED_Common} from "../../../models/validator/validator_led_common";
import {Acceptor_Common} from "../../../models/acceptor/acceptor_common";
import {Acceptor_DcDc_Boost} from "../../POWER/dcdc/acceptor/dcdc_boost_acceptor";
import {Acceptor_DcDc_Buck} from "../../POWER/dcdc/acceptor/dcdc_buck_acceptor";
import {Acceptor_DcDc_BuckBoost} from "../../POWER/dcdc/acceptor/dcdc_buck_boost_acceptor";
import {Acceptor_DcLED_FloatingBuckBoost,} from './acceptor/dcLED_FloatingBuckBoost_acceptor';
import {Validator_DcLED_FloatingBuckBoost} from './validator/dcLED_floating_buck_boost_validator';


export class Led_DcDc_Factory {

  private static createAcceptor(a: Ic): IAcceptor {
    // a:Ic cannot be never null

    switch (a.topology.toLowerCase()) {
      case TOPOLOGY_BOOST                 :
      case TOPOLOGY_FLOATING_BOOST        :
        return new Acceptor_DcDc_Boost(true); // injector.getInstance(Acp_onSpec_Boost);
      case TOPOLOGY_BUCK                  :
        return new Acceptor_DcDc_Buck(true); // injector.getInstance(Acp_onSpec_BuckBoost);
      case TOPOLOGY_INVERTING_BUCK_BOOST  :
        return new Acceptor_DcLED_LEDBuckBoost(); // injector.getInstance(Acp_onSpec_InvertingBuckBoost);
      case TOPOLOGY_POSITIVE_BUCK_BOOST   :
        return new Acceptor_DcDc_BuckBoost(true); // injector.getInstance(Acp_onSpec_798xBuckBoost);
      case TOPOLOGY_FLOATING_BUCK_BOOST   :
        return new Acceptor_DcLED_FloatingBuckBoost(); // injector.getInstance(Acp_onSpec_798xBuckBoost);
      default                             :
        return new Acceptor_Common(true);
    }
  }

  private static createUpdateDesign(a: Ic): IUpdateDesign {

    switch (a.topology.toLowerCase()) {
      case TOPOLOGY_BOOST                 :
      case TOPOLOGY_BUCK_BOOST            :
      case TOPOLOGY_POSITIVE_BUCK_BOOST   :
      case TOPOLOGY_INVERTING_BUCK_BOOST  :
      case TOPOLOGY_FLOATING_BOOST        :
        return new UpdateDesign_DcLED_BuckBoost();
      case TOPOLOGY_BUCK                  :
        return new UpdateDesign_DcLED_Buck();
      default                             :
        return new UpdateDesign();
    }

  }

  private static createComparator(): IComparator {return new Comparator_DcDc()}

  private static createValidator(a: Ic): IValidator {
    if (isNull(a))
      return new Validator_LED_Common();

    switch (a.topology.toLowerCase()) {
      case TOPOLOGY_BUCK 	           :
        return new Validator_DcLED_Buck();
      case TOPOLOGY_BOOST            :
      case TOPOLOGY_FLOATING_BOOST   :
        return new Validator_DcLED_Boost();
      case TOPOLOGY_POSITIVE_BUCK_BOOST:
        return new Validator_DcLED_PositiveBuckBoost();
      case TOPOLOGY_INVERTING_BUCK_BOOST:
        return new Validator_DcLED_BuckBoost();
      case TOPOLOGY_FLOATING_BUCK_BOOST:
        return new Validator_DcLED_FloatingBuckBoost();
      default:
        return new Validator_LED_Common();
    }
  }

  private static createStdFeature(): Feature[] { return [
      {feature: {label: "LED Dedicated", level: 1001}}
    , {feature: {label: "Multi-Channel", level: 1002}}
    , {feature: {label: "PWM Dimming", category: "Pin", level: 1003}}
  ];}

  public static createService(): IAppFactoryService {
    return {
      acceptorCreator     : Led_DcDc_Factory.createAcceptor,
      updateDesignCreator : Led_DcDc_Factory.createUpdateDesign,
      comparator          : Led_DcDc_Factory.createComparator(),
      validatorCreator    : Led_DcDc_Factory.createValidator,
      stdFeatures         : Led_DcDc_Factory.createStdFeature()
    }
  }

}
